import React from "react";
import styles from "./currencyListItems.module.scss";

export type TCurrencyListItem = {
  currencyName: string;
  flagSrc: string;
  itemIndex: number;
  itemType: string;
  clickHandler?: (event: React.MouseEvent<HTMLElement>) => void;
  keyDownHandler?: (event: React.KeyboardEvent<HTMLLIElement>) => void;
};

function CurrencyListItem({
  itemIndex,
  itemType,
  flagSrc,
  currencyName,
  clickHandler,
}: TCurrencyListItem) {
  return (
    <li
      data-testid="currency-list-item"
      onClick={clickHandler}
      data-item-index={itemIndex}
      data-item-type={itemType}
      role="menuitem"
      className={styles.listItem}
      tabIndex={0}
    >
      <span className={styles.listItemContainer}>
        <div className={styles.flagWrapper}>
          <img
            src={flagSrc}
            className={styles.currencyFlag}
            alt=""
          />
        </div>
        <span className={styles.currencyInfo}>{currencyName}</span>
      </span>
    </li>
  );
}

export default CurrencyListItem;
